// extracted by mini-css-extract-plugin
export default {"prizeBox":"PrizeBox_prizeBox__pH5Ij","yellow":"PrizeBox_yellow__mI2zq","purple":"PrizeBox_purple__F62xg","textPart":"PrizeBox_textPart__bXfY8"};